import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";

import OrderNotificationModalComponent from "../../components/global/modal/OrderNotificationModal";

class OrderNotificationModal extends Component {
    intervalId = null;

    constructor(props) {
        super(props);

        this.state = {
            countdown: 4
        };
    }

    closeModal = () => {
        this.props.dispatchCloseOrderNotificationModalAction();
    };

    getCountdown = () => {
        return this.state.countdown;
    };

    closeInterval = () => {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;

            this.setState({
                countdown: -1
            });
        }
    };

    componentDidMount() {
        if (this.intervalId === null) {
            let self = this;
            this.intervalId = setInterval(function () {
                if (self.getCountdown() === 1) {
                    self.closeInterval();
                    self.closeModal();
                } else {
                    self.setState({
                        countdown: self.getCountdown() - 1
                    });
                }
            }, 1000);
        }
    }

    componentWillUnmount() {
        this.closeInterval();
    }

    addNewToDispenseTab = () => {
        this.props.dispatchAddNewToDispenseTabAction();
        this.closeModal();
    };

    render() {
        return (
            <OrderNotificationModalComponent
                closeModal={this.closeModal}
                openToDispenseOrders={this.addNewToDispenseTab}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseOrderNotificationModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.ORDER_NOTIFICATION_MODAL));
        },
        dispatchAddNewToDispenseTabAction: () => {
            dispatch(navigationActions.addNewToDispenseTab());
        }
    };
};

export default OrderNotificationModal = connect(mapStoreToProps, mapDispatchToProps)(OrderNotificationModal);
